import { gql } from "graphql-tag"

import vendor from "./vendor"

export default gql`
  ${vendor}

  fragment Label on Label {
    brandAliases
    createdAt
    id
    imprintOfLabelId
    isPublished
    publishedAt
    status
    updatedAt
    url
    vendor {
      ...Vendor
    }
  }
`
